import { Link, Outlet, useLocation } from 'react-router-dom';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useAuth } from '../../auth/auth-hooks';
import './LayoutComponent.css';

export function Layout(): JSX.Element {
  const location = useLocation();
  const { user, logout, toggleDarkMode } = useAuth();

  if (!user) {
    return <div>Loading...</div>;
  }

  const isDark = user.preferences?.darkMode ?? false;

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <Link to="/dashboard" className="logo">
            <img src="/images/Kibo-Icon-Black.png" alt="Kibo" height="28" />
          </Link>

          <div className="header-right">
            <nav className="nav">
              <Link
                to="/dashboard"
                className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
              >
                Dashboard
              </Link>
              {/* Everyone gets the admin hub; it shows only the tiles they can open. */}
              <Link
                to="/admin"
                className={`nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}
              >
                Admin
              </Link>
            </nav>

            <div className="user-menu">
              <DarkModeSwitch
                checked={isDark}
                onChange={() => void toggleDarkMode()}
                size={18}
                sunColor="var(--color-text-secondary)"
                moonColor="var(--color-text-secondary)"
                className="theme-toggle-btn"
                aria-label="Toggle dark mode"
              />
              <Link to="/preferences" className="user-name-link">
                {user.displayName}
              </Link>
              <button onClick={() => void logout()} className="btn btn-outline logout-btn">
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
